import { render, staticRenderFns } from "./InformasiLainnya-Mobile.vue?vue&type=template&id=40d9e32e&scoped=true&"
import script from "./InformasiLainnya-Mobile.vue?vue&type=script&lang=js&"
export * from "./InformasiLainnya-Mobile.vue?vue&type=script&lang=js&"
import style0 from "./InformasiLainnya-Mobile.vue?vue&type=style&index=0&id=40d9e32e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d9e32e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VLayout})
